import React from 'react';

import { Toggle } from 'common/components';

import styles from './Header.module.scss';

type HeaderProps = {
    isActive: boolean;
    onToggle: () => void;
};

const Header = ({ isActive, onToggle }: HeaderProps) => {
    return (
        <header className={styles.agentCommandCenterHeader}>
            <h1>Agent Command Center</h1>
            <div className={styles.agentCommandCenterHeaderRight}>
                <span className='text-md font-bold'>Inactive</span>
                <Toggle size='lg' checked={isActive} onChange={onToggle} aria-label='Agent availability' />
                <span className='font-bold'>Active</span>
            </div>
        </header>
    );
};

export default Header;
